import './NotificationSettings.scss';

import { useState } from 'react';

function NotificationSettings() {
    const [isNotifsChecked, setIsNotifsChecked] = useState(false);

    return (
        <section className='notifs'>
            <div className='notifs__field'>
                <p className='notifs__field-text'>
                    Allow notifications
                </p>

                <div className={`slide-button ${isNotifsChecked ? 'checked' : ''}`} onClick={() => setIsNotifsChecked(!isNotifsChecked)}>
                    <div className="slider"></div>
                </div>
            </div>
        </section>
    )
}

export default NotificationSettings;
